module.exports = __webpack_public_path__ + "media/images/profile_header-539176f4adefcd073e4d1572d86a032d.jpg";